<template>
    <ExtendedLayout
        :user="user"
        currentTab="vacations"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2 mb-4">
                <InertiaLink :href="$route('admin::users.vacations.index', { user: user.id })">
                    <ChevronLeftIcon class="w-4 h-4 text-gray-500" />
                </InertiaLink>
                {{ __('admin::general.create_model', {'model': __('admin::vacations.vacation').toLowerCase() }) }}
            </Heading>

            <form @submit.prevent="submit">

                <VacationForm
                    v-model="form"
                    :userOptions="userOptions"
                    :vacationMessageDefault="vacationMessageDefault"
                    managerMode
                />

                <Button :loading="form.processing">
                    {{ __('admin::general.create_model', {'model': __('admin::vacations.vacation').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';
import {ChevronLeftIcon} from "@heroicons/vue/outline";

export default {
    components: {
        ChevronLeftIcon,
        ExtendedLayout,
    },
    props: {
        user: Object,
        userOptions: Object,
        vacationMessageDefault: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                starts_at: null,
                ends_at: null,
                returns_at: null,
                days_to_show_notice_before_start: null,
                deputy_user_id: null,
                comment: null,
                use_default_messages: true,
                appendix_before_vacation_message: this.vacationMessageDefault?.appendix_before_vacation_message || null,
                appendix_during_vacation_message: this.vacationMessageDefault?.appendix_during_vacation_message || null,
                autoreply_subject: this.vacationMessageDefault?.autoreply_subject || null,
                autoreply_message: this.vacationMessageDefault?.autoreply_message || null,
                is_approved: true,
                synced_with_salary: false,
            })
        }
    },
    methods: {
        submit() {
            this.form
                .post(this.$route('admin::users.vacations.store', { user: this.user.id }));
        },
    }
}
</script>
